import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface Toast {
  id: string;
  message: string;
  type: 'success' | 'error' | 'info';
}

interface UiState {
  toasts: Toast[];
  modalOpen: boolean;
  modalContent: string | null;
  bottomSheetOpen: boolean;
}

const initialState: UiState = {
  toasts: [],
  modalOpen: false,
  modalContent: null,
  bottomSheetOpen: false,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    addToast(state, action: PayloadAction<Omit<Toast, 'id'>>) {
      state.toasts.push({ ...action.payload, id: Date.now().toString() });
    },
    removeToast(state, action: PayloadAction<string>) {
      state.toasts = state.toasts.filter((t) => t.id !== action.payload);
    },
    openModal(state, action: PayloadAction<string>) {
      state.modalOpen = true;
      state.modalContent = action.payload;
    },
    closeModal(state) {
      state.modalOpen = false;
      state.modalContent = null;
    },
    openBottomSheet(state) { state.bottomSheetOpen = true; },
    closeBottomSheet(state) { state.bottomSheetOpen = false; },
  },
});

export const { addToast, removeToast, openModal, closeModal, openBottomSheet, closeBottomSheet } = uiSlice.actions;
export default uiSlice.reducer;

export const selectToasts = (state: { ui: UiState }) => state.ui.toasts;
export const selectModalOpen = (state: { ui: UiState }) => state.ui.modalOpen;
